import { ComponentFactoryResolver, Directive } from '@angular/core';
import { DynamicComponentConfig } from './dynamic-component-config.model';
import { DynamicComponentHostDirective } from './dynamic-component-host.directive';
import { DynamicComponent } from './dynamic-component.model';

@Directive()
export abstract class DynamicComponentHost {
  private host: DynamicComponentHostDirective;

  constructor(protected componentFactoryResolver: ComponentFactoryResolver) { }

  protected renderComponentForItem(dynamicComponentConfig: DynamicComponentConfig) {
    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(dynamicComponentConfig.componentToRender);

    const viewContainerRef = this.host.viewContainerRef;
    viewContainerRef.clear();

    const componentRef = viewContainerRef.createComponent<DynamicComponent>(componentFactory);
    componentRef.instance.inputData = dynamicComponentConfig.inputData;
  }

  protected initHost(dynamicComponentHost: DynamicComponentHostDirective) {
    this.host = dynamicComponentHost;
  }
}
